import { Box, Link, Typography } from '@mui/material';
import React, { ReactNode } from 'react';
import useIsMobileDevice from '../../hooks/useIsMobileDevice';
import sideBg from './../../assets/img/login-side-background.png';
import { ReactComponent as ViprLogo } from '../../assets/icons/logo/icon.svg';
import { ReactComponent as ViprText } from '../../assets/icons/logo/text.svg';
import appStoreBadge from '../../assets/img/icons/app-store-white.png';
import googlePlayBadge from '../../assets/img/icons/google-play-white.png';

type LoginContainerProps = {
  children: ReactNode;
};

const LoginContainer = (props: LoginContainerProps) => {
  const isMobile = useIsMobileDevice();

  return <Box
    display={'flex'}
    width={'100%'}
    height={'100%'}
    bgcolor={'#000000'}
    position={'relative'}
    style={{
      overflowY: 'auto',
    }}
  >
    <Box position={'absolute'}
      width={'58%'}
      left={'-16%'}
      top={'-13%'}
      sx={{
        aspectRatio: '2.5',
        borderRadius: '58%',
        opacity: '0.4',
        background: 'rgba(93, 117, 151, 1)',
        filter: 'blur(200px)',
      }}
      zIndex={0}
    >

    </Box>
    <Box
      flex={isMobile ? 1 : 55}
      zIndex={1}
      height={'100%'}
      display={'flex'}
      flexDirection={'column'}
      alignItems={'center'}
    >
      <Box
        display={'flex'}
        flexDirection={'column'}
        flex={1}
        gap={isMobile ? '40px' : '80px'}
        width={isMobile ? '85%' : '55%'}
        minWidth={isMobile ? 0 : 'fit-content'}
        maxWidth={'440px'}
        px={isMobile ? 1 : 0}
        justifyContent={'center'}
      >
        <Box>
          <ViprLogo width={'36px'} height={'36px'}/>
        </Box>
        <Box padding={'48px 0px'}>
          {props.children}
        </Box>
      </Box>
      <Box
        display={'flex'}
        flexDirection={'column'}
        width={'100%'}
        padding={isMobile ? '10px 20px' : '10px 40px'}
        alignItems={isMobile ? 'center' : 'flex-start'}
        gap={'12px'}
      >
        {isMobile && (
          <Box
            display={'flex'}
            gap={'12px'}
            alignItems={'center'}
          >
            <Link
              href="https://apps.apple.com/us/app/vipr/id1609428226"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Box
                component="img"
                src={appStoreBadge}
                alt="Download on the App Store"
                sx={{ height: 36 }}
              />
            </Link>
            <Link
              href="https://play.google.com/store/apps/details?id=ai.vipr.android&hl=en_US"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Box
                component="img"
                src={googlePlayBadge}
                alt="Get it on Google Play"
                sx={{ height: 36 }}
              />
            </Link>
          </Box>
        )}
        <Typography
          variant='tsm'
          color={(t) => t.palette.grey[500]}
        >
          © VIPR.ai {new Date().getFullYear()}
        </Typography>
      </Box>
    </Box>
    <Box
      flex={45}
      zIndex={1}
      height={'100%'}
      display={isMobile ? 'none' : 'flex'}
      padding={'20px 20px 20px 0px'}
      color={(t) => t.palette.base.bodyText}
    >
      <Box
        border={'1px solid #FFFFFF33'}
        overflow={'clip'}
        height={'100%'}
        display={'flex'}
        width={'100%'}
        sx={{
          background: `url(${sideBg})`,
          backgroundSize: 'cover',
          borderRadius: '12px',
          backgroundClip: 'padding-box',
        }}
        position={'relative'}
      >
        <Box position={'relative'}
          width={'100%'}
          height={'100%'}
          sx={{
            background: 'linear-gradient(180deg, #000 0%, rgba(0, 0, 0, 0.00) 50%, #000 100%)',
          }}
          display={'flex'}
          flexDirection={'column'}
          justifyContent={'space-between'}>

          <Box display={'flex'} flexDirection={'column'}>
            <Box display={'flex'}
              alignItems={'center'}
              padding={'40px'}
              gap={'16px'}>
              <ViprLogo/>
              <ViprText/>
            </Box>
            <Box display={'flex'}
              flexDirection={'column'}
              padding={'0px 80px 40px'}
              gap={'6px'}>
              <Typography variant='dsm'
                fontWeight={600}>Scan. Search. Solve.™</Typography>
              <Typography variant='dxs'
                lineHeight={'30px'}
                sx={{
                  opacity: '0.7',
                }}>Detect more and prevent more with vehicle intelligence</Typography>
            </Box>
          </Box>

          <Box>
            <Box display={'flex'}
              flexDirection={'column'}
              padding={'40px'}
              gap={'16px'}>
              <Box>
                <Typography variant='tsm' fontWeight={500}>Experiencing issues?</Typography>
                <Typography
                  variant='tsm'
                  fontWeight={500}>Get assistance via <Link href='mailto:support@vipr.ai'
                    sx={{
                      color: (t) => t.palette.base.bodyText,
                      textDecoration: 'underline',
                    }}>support@vipr.ai</Link>
                </Typography>
              </Box>
              <Box
                display={'flex'}
                gap={'12px'}
                alignItems={'center'}
              >
                <Link
                  href="https://apps.apple.com/us/app/vipr/id1609428226"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Box
                    component="img"
                    src={appStoreBadge}
                    alt="Download on the App Store"
                    sx={{ height: 40 }}
                  />
                </Link>
                <Link
                  href="https://play.google.com/store/apps/details?id=ai.vipr.android&hl=en_US"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Box
                    component="img"
                    src={googlePlayBadge}
                    alt="Get it on Google Play"
                    sx={{ height: 40 }}
                  />
                </Link>
              </Box>
            </Box>
          </Box>

        </Box>
      </Box>
    </Box>
  </Box>;
};

export default LoginContainer;
